// http://kazupon.github.io/vue-i18n/en/messages.html
export default {
  '{0} Amount': '{0} Quantité',
  '{0} couldn\'t be loaded': '{0} n\'a pu être chargé',
  '{0} Product(s)': '{0} Produit(s)',
  '{0} has been loaded.': '{0} a été chargé.',
  '{0} have been saved': '{0} ont été sauvés',
  '{attribute} can\'t be empty.': '{attribute} ne peut pas être vide.',
  '{attribute} can\'t contain more than {max} characters.': '{attribute} ne peut pas contenir plus que {max} caractères.',
  '{attribute} can\'t contain less than {min} characters.': '{attribute} ne peut pas contenir moins que {max} caractères.',
  '{attribute} should be less than {max}.': '{attribute} doit être moins que {max}.',
  '{attribute} should be a valid e-mail address.': '{attribute} devrait être une adresse email valide.',
  '{attribute} should only contain numeric values.': '{attribute} ne peut contenir que des valeurs numériques.',
  '{attribute} should be higher than {min}.': '{attribute} devrait être plus élevé que {min}.',
  '{0} Payments': '{0} Paiements',
  'Add {0}': 'Ajouter {0}',
  'Add to {0}': 'Ajouter à {0}',
  'Addition:': 'Toeslag',
  'Additional {0}': 'Additionnel {0}',
  'Add New': 'Ajouter un nouveau',
  'Add or remove cash by clicking on the button right below.': 'Ajouter ou supprimer de l\'argent en cliquant sur le buton juste en dessous.',
  'Add products to the inventory count by scanning or searching them in the box below.': 'Ajouter des produits au décompte des stocks en les scanner ou en les cherchant dans la case ci-dessous.',
  'Add received goods to the inventory stock.': 'Ajouter des produits reçus au stock d\'inventaire.',
  'Address': 'Adresse',
  'Amount': 'Montant',
  'All': 'Tout',
  'All Items': 'Tous articles',
  'All products will be imported': 'Tous les produits seront importés',
  'A new version of the software is available.': 'Une nouvelle version du logiciel est disponible.',
  'And': 'Et',
  'Apply {0}': 'Appliquer {0}',
  'Are you sure?': 'Êtes-vous sûr ?',
  'Articles': 'Articles',
  'Artnr.': 'Numéro d\'article',
  'Apartment, suite, unit, etc.': 'Appartement, suite, unité, etc.',
  'At the start of each business day, you must open your register and add the starting balance.': 'Au début de chaque jour, vous devez ouvrir votre caisse et commencer l\'équilibrage.',
  'Back': 'Retour',
  'Barcode': 'Code barre',
  'Before continuing, you need to configure the cash register.': 'Avant de continuer, vous devez configurer la Caisse.',
  'Bestsellers': 'Meilleures ventes',
  'Bills': 'Billets',
  'Born before: {0}': 'Né avant : {0}',
  'Brand': 'Marque',
  'Cancel': 'Annuler',
  'Canceled': 'Annulé',
  'Card': 'Carte',
  'Cart': 'Panier d\'achat',
  'Cash': 'Argent',
  'Cash Flow': 'Flux de trésorerie',
  'Cash-In': 'Argent entrant',
  'Cash-Out': 'Argent sortant',
  'Cash Management': 'Gestion de la trésorerie',
  'Cash Movements': 'Mouvements de trésorerie',
  'Cash Payments Received': 'Paiements en espèces reçus',
  'Cash Register': 'Caisse',
  'Cash Register is closed': 'La caisse est fermée',
  'Cash Register Code': 'Code De Caisse',
  'Catalog': 'Catalogue',
  'Change receipt language': 'Changer la langue du ticket',
  'Check Code': 'Vérifier le code',
  'Checking the network cable or router': 'Vérifiez le câble réseau ou router',
  'Checkout': 'Check-out',
  'Choose a {0}': 'Choisis un {0}',
  'Choose an {0}': 'Choisis un {0}',
  'City': 'Ville',
  'Clear': 'Vide',
  'Clear Cart': 'Vider',
  'Close': 'Fermer',
  'Close {0}': 'Fermer {0}',
  'Close Register': 'Fermer la caisse',
  'Closed': 'Fermé',
  'Closure #': 'Fermeture #',
  'Coins': 'Pièces de monnaie',
  'Complete': 'Complèter',
  'Complete {0}': 'Complèter {0}',
  'Completed': 'Complété',
  'Configure this cash register below.': 'Configurer cette caisse enregistreuse ci-dessous.',
  'Contact an administrator.': 'Contacter un administrateur.',
  'Contact Information': 'Information de contact',
  'Continue': 'Continuez',
  'Count': 'Décompte',
  'Counted': 'Compté',
  'Counted Number': 'Nombre compté',
  'Country': 'Pays',
  'Country code': 'Code pays',
  'Current Stock': 'Stock actuel',
  'Customer': 'Client',
  'Customer Discount': 'Remise client',
  'Customers': 'Clients',
  'Date': 'Date',
  'Date Of Birth': 'Date De Naissance',
  'Delete': 'Supprimer',
  'Delete {0}': 'Supprimer {0}',
  'Description': 'Déscription',
  'Detailed cash count': 'Décompte détaillé',
  'Details': 'Détails',
  'Difference': 'Différence',
  'Discount': 'Réduction',
  'Dutch': 'Néerlandais',
  'Edit': 'Editer',
  'Edit {0}': 'Editer {0}',
  'English': 'Anglais',
  'Email': 'Email',
  'Email Address': 'Adresse Email',
  'Employee': 'Employé',
  'Enter a {0}': 'Entrer un {0}',
  'Enter an amount': 'Entrer un montant',
  'Example': 'Exemple',
  'Exclude products that are out of stock': 'Exclure produits hors stock',
  'Expected': 'Prévu',
  'Filter': 'Filter',
  'Finish': 'Fin',
  'First Name': 'Prénom',
  'Fixed Amount': 'Montant Fixé',
  'Free Samples': 'Échantillons gratuits',
  'French': 'Français',
  'Full': 'Plein',
  'Full {0}': 'Plein {0}',
  'Full Screen': 'Écran plein',
  'General': 'Général',
  'Gift Card': 'Chèque cadeau',
  'Give {0}': 'Donner {0}',
  'Give A Discount': 'Donner Une Réduction',
  'Guest': 'Visiteur',
  'Go Back': 'Retourner',
  'How many items should be given as sample?': 'Combien d’articles à donner comme échantillon ?',
  'Import {0}': 'Import {0}',
  'Import a set of products (f.e. all products of a specific brand) by scanning the QR code on a created inventory list.': 'Importer un set de produits (p.e. tous les produits d’une marque) en scannant le code QR d’une liste d’inventaire créé.',
  'Import the products of an incoming order by scanning its QR code.': 'Importer les produits d’une commande entrante en scannant le code QR.',
  'Include all products in this inventory count.': 'Inclure tous les produits dans ce décompte des stocks.',
  'Incoming Order': 'Commande Entrante',
  'Installation': 'Installation',
  'Installation Date': 'Date d\'installation',
  'Inventory Count': 'Décompte des stocks',
  'Inventory Counts': 'Décompte des stocks',
  'Inventory List': 'Liste d\'inventaire',
  'Inventory Lists': 'Listes d\'inventaire',
  'Items that you count will appear here one-by-one to help you keep track.': 'Les éléments que vous comptez apparaîtront ici un par un pour vous aider à faire le suivi.',
  'Language': 'Langue',
  'Last Name': 'Nom De Famille',
  'Last register closure summary': 'Résumé de la dernière fermeture de la caisse',
  'Less': 'Moins',
  'Load {0}': 'Charger {0}',
  'Login': 'Login',
  'Logout': 'Se déconnecter',
  'Max. Characters: {0}': 'Max. Caractères: {0}',
  'Minute': 'Minute',
  'Minutes': 'Minutes',
  'More': 'Plus',
  'Multiple products found for barcode: "{0}".': 'Trouvé plusieurs produits pour code barre "{0}"',
  'Name': 'Nom',
  'Next': 'Suivant',
  'No results found.': 'Aucun résultat trouvé.',
  'Normal Screen': 'Écran normal',
  'Not yet counted': 'Pas encore compté',
  'Number of {0}': 'Nombre de {0}',
  'No': 'Non',
  'No {0}': 'Non {0}',
  'None': 'Aucun',
  'Note': 'Note',
  'Nr': 'N°',
  'Unique Code': 'Code Unique',
  'Once you complete your register closure, all of the day\'s cash (including any cash movements and float) should be counted. If you decide to remove some redundant cash from the drawer you should enter this at "Safedrop".': 'Une fois que vous avez terminé la fermeture de la caisse, toutes les espèces de la journée (y compris les mouvements d\'espèces et les fonds de caisse) devraient être comptées. Si vous décidez de retirer de l\'argent excédentaire du tiroir-caisse, vous devez le saisir dans "Safedrop".',
  'Open': 'Ouvrir',
  'Open {0}': 'Ouvrir {0}',
  'Open Drawer': 'Ouvrir le tiroir',
  'Open Cash Register': 'Ouvrir la caisse',
  'Open/Close': 'Ouvrir/fermer',
  'Opened': 'Ouvert',
  'Opened At': 'Ouvert à',
  'Opening Float': 'Montant initial',
  'Opt-In to Marketing and Promotional Emails': 'Opt-In aux e-mails marketing et promotionnels',
  'Opt-In to Informative Emails': 'Opt-In aux e-mails informatifs',
  'Order': 'Commande',
  'Order Nr.': 'Numéro de commande',
  'Orders': 'Commandes',
  'Other': 'Autre',
  'Outgoing Order': 'Commande Sortante',
  'Outstanding Balance': 'Montant Impayé',
  'Park Receipt': 'Ticket En Attente',
  'Parked Receipts': 'Tickets d\'attente',
  'Parked Sales': 'En attente de vente',
  'Partial': 'En Partie',
  'Partial {0}': 'En Partie {0}',
  'Pay': 'Payer',
  'Payment Method': 'Mode De Paiement',
  'Payment Type': 'Type De Paiement',
  'Payments': 'Paiements',
  'Pending': 'En Attente',
  'Percent': 'Pourcent',
  'Percentage': 'Pourcentage',
  'Phone': 'Téléphone',
  'PIN Code': 'Code PIN',
  'Postal Code': 'Code Postal',
  'Previous Count': 'Compte Précédent',
  'Price': 'Prix',
  'Print': 'Imprimer',
  'Printer': 'Imprimante',
  'Printerlist': 'Liste des imprimantes',
  'Processed by {0}': 'Traité par {0}',
  'Product': 'Produit',
  'Products': 'Produits',
  'Quantity': 'Quantité',
  'Quantity of {0}': 'Quantité de {0}',
  'QZ Tray is not installed yet!': 'QZ Tray n\'est pas encore installé!',
  'Receipt': 'Ticket',
  'Receipt will be automatically completed': 'Les reçu sera automatiquement complété',
  'Receipts': 'Tickets',
  'Receipt Discount': 'Coupon de Réduction',
  'Reconnecting to Wi-Fi': 'Reconnexion au wifi',
  'Refund': 'Remboursement',
  'Register': 'Caisse',
  'Reload': 'Recharge',
  'Resetting the modem or router': 'Réinitialisation du modem ou routeur',
  'Results': 'Résultats',
  'Return an item': 'Retourner un article',
  'Register Closure': 'Fermeture de la caisse',
  'Register Closures': 'Fermetures de la caisse',
  'Register closures are a basic part of retail that allow you to physically check your cash and credit totals against their recorded totals.': 'Les fermetures de caisse sont un élément de base de la vente au détail qui vous permet de vérifier physiquement vos totaux d\'argent comptant et de crédit par rapport à leurs totaux enregistrés.',
  'Replace': 'Remplacer',
  'Reload {0}': 'Recharger {0}',
  'Remove {0}': 'Retirer {0}',
  'Rounded': 'Arrondi',
  'Row Discount': 'Remise de Rangée',
  'Safedrop': 'Dépôt',
  'Sales': 'Ventes',
  'Sales History': 'Historique Des Ventes',
  'Save': 'Enregistrer',
  'Schedule a full or partial inventory count to maintain accurate inventory levels.': 'Planifiez un décompte des stocks complet ou partiel pour maintenir des niveaux d\'inventaire précis.',
  'Search': 'Recherche',
  'Search {0}': 'Recherche {0}',
  'Seconds': 'Secondes',
  'Select a {0}': 'Choissir un {0}',
  'Select {0}': 'Choissir {0}',
  'Select the correct product below.': 'Sélectionner le produit adéquat ci-dessous',
  'Send {0}': 'Envoyer {0}',
  'Set {0} items to {1}': 'Mettez {0} articles sur {1}',
  'Set an opening float to open the register and make a sale.': 'Définir un montant initial pour ouvrir la caisse et faire une vente.',
  'Settings': 'Préférences',
  'Show {0}': 'Montrer {0}',
  'Since': 'Depuis',
  'SKU': 'SKU',
  'Specify the products to include in this inventory count.': 'Spécifiez les produits à inclure dans ce dénombrements des stocks.',
  'Staff Discount': 'Remise de personnel',
  'Staff Note': 'Note Du Personnel',
  'Store': 'Magasin',
  'Store Catalog': 'Catalogue magasin',
  'Subtotal': 'Sous-total',
  'Summary': 'Résumé',
  'Thank you for your purchase at {0}!': 'Merci pour votre achat à {0}!',
  'The Cart Is Empty.': 'Le Panier Est Vide.',
  'The counted amount doesn\'t match the expected amount.': 'Le montant compté ne correspondant pas au montant attendu.',
  'The difference is {0}.': 'La différence est de {0}',
  'The item(s) will be re-added to the stock': 'Le(s) produit(s) seront rajoutés au stock',
  'The item(s) won\'t be re-added to the stock': 'Le(s) produit(s) ne seront pas rajoutés au stock',
  'The order has been completed': 'La commande est terminée',
  'The order has been fully paid for': 'La commande a été payée',
  'There is no internet connection': 'Il n’y a pas de connexion au réseau',
  'This cash register has already been installed.': 'Cette caisse est déjà installée.',
  'This cash register has already been open for more than a day.': 'Cette caisse est déjà ouverte depuis plus d\'une journée.',
  'This cash register needs to be initialized first. Please fill in the unique code in the form below and follow further instructions.': 'Cette caisse doit d\'abord être installé. Veuillez remplir le code unique dans le formulaire ci-dessous et suivre d\'autres instructions.',
  'This computer hasn\'t been configured as a cash register yet.': 'Cet ordinateur n\'est pas encore configuré comme caisse enregistreuse.',
  'This e-mail address is already in our database.': 'Cette adresse email existe déjà dans notre base de données.',
  'This is correct': 'C\'est correct',
  'This is not a valid QR Code': 'Ceci n’est pas un code QR valide',
  'This note will be visible on the printed receipt.': 'Cette note sera visible sur le ticket imprimé.',
  'This allows you to track any additional money you put into your cash drawer. This is used to increase your float amount during the day if required.': 'Cela vous permet de suivre l\'argent supplémentaire que vous mettez dans votre tiroir-caisse. Ceci est utilisé pour augmenter le montant de votre caisse pendant la journée si nécessaire.',
  'Throughout the day you may want to add or remove cash from the cash drawer.': 'Durant la journée vous voudrez ajouter ou retirer de l\'argent du tiroir-caisse.',
  'Time': 'Temps',
  'To refund': 'Rembourser',
  'Total {0}': 'Total {0}',
  'Total': 'Total',
  'Totals': 'Total',
  'Uncounted': 'Non compté',
  'Unique nr.': 'N° unique',
  'Unit price': 'Prix unitaire',
  'Use The Google API For Address Lookup': 'Utiliser L\'API Google Pour La Recherche D\'adresse',
  'View All': 'Voir Tout',
  'VAT': 'TVA',
  'Verify if the information below is correct.': 'Vérifier si les informations ci-dessous sont correctes.',
  'Walk In': 'Visiteur',
  'We recommend to close the cash register before registering the next sale.': 'Nous vous recommandons de fermer la caisse avant d\'enregistrer la prochaine vente.',
  'Welcome {0}': 'Bienvenue {0}',
  'Why should the drawer be opened?': 'Pourquoi le tiroir devrait-il être ouvert?',
  'Yes': 'Oui',
  'You didn\'t select a printer.': 'Vous n\'avez pas sélectionné un imprimante.',
  'You Have Already Applied A Receipt Discount.': 'Vous avez déjà appliqué une remise.',
  'Your computer is offline': 'Votre ordinateur est offline',
  'Your last counted items': 'Vos derniers articles comptés',
  'You can use this option to track any cash you remove from your cash drawer. Cash out can be used to track actions such as safe drops, where you may need to remove cash from your drawer during the day for safekeeping.': 'Vous pouvez utiliser cette option pour suivre tout l\'argent que vous retirez de votre tiroir-caisse. Argent sortant peut être utilisé pour suivre les actions telles que les safedrops, où vous devrez peut-être retirer de l\'argent de votre tiroir pendant la journée pour la conservation.',
  'You need to type something here!': 'Vous devez taper quelque chose ici!',
  'You were helped by {0}': 'Vous avez été aidé par {0}'
}



// WEBPACK FOOTER //
// ./src/i18n/fr/index.js